import { w as warn, d as deprecated } from './6cf04c83.mjs';

function getFirstElementByTagName(tagName, w = window) {
  return w.document.getElementsByTagName(tagName)[0];
}
function getHeadElement(w = window) {
  return getFirstElementByTagName("head", w);
}
function getBodyElement(w = window) {
  return getFirstElementByTagName("body", w);
}
function hasClassInParents(ele, className) {
  let test = ele;
  for (; test && test !== document; test = test.parentNode) {
    if (test.classList.contains(className)) {
      return true;
    }
  }
  return false;
}
function getParentByClassName(ele, className) {
  let test = ele;
  for (; test && test !== document; test = test.parentNode) {
    if (test.classList.contains(className)) {
      return test;
    }
  }
  return null;
}
function stringToDocumentFragment(htmlString) {
  const wrapperElement = document.createElement("div");
  const documentFragment = document.createDocumentFragment();
  if (typeof htmlString !== "string") {
    warn(
      `stringToDocumentFragment should be called with strings containing html only, but was called with ${typeof htmlString}`
    );
    return documentFragment;
  }
  wrapperElement.innerHTML = htmlString.trim();
  while (wrapperElement.hasChildNodes()) {
    documentFragment.appendChild(wrapperElement.firstChild);
  }
  return documentFragment;
}
function getElementsByClassname(parentElement, className) {
  deprecated(
    "o_util.dom.getElementsByClassname",
    "use native document.getElementsByClassName instead"
  );
  return parentElement.getElementsByClassName(className);
}
function hasClass(element, className) {
  deprecated("o_util.dom.hasClass", "use native element.classList.contains instead");
  let classList = "";
  if (element && element.getAttribute("class")) {
    classList = element.getAttribute("class");
  } else if (element && element.className) {
    classList = element.className;
  }
  return !!classList && !!classList.match ? !!classList.match(new RegExp(`(\\s|^)${className}(\\s|$)`)) : false;
}
function addClass(ele, cls) {
  deprecated("o_util.dom.addClass", "use native element.classList.add instead");
  if (!hasClass(ele, cls)) {
    ele.className += ` ${cls}`;
  }
}
function removeClass(ele, cls) {
  deprecated("o_util.dom.removeClass", "use native element.classList.remove instead");
  ele.classList.remove(cls);
}
function toggleClass(ele, cls) {
  deprecated("o_util.dom.toggleClass", "use native element.classList.toggle instead");
  ele.classList.toggle(cls);
}

var index = /*         */Object.freeze({
  __proto__: null,
  addClass: addClass,
  getBodyElement: getBodyElement,
  getElementsByClassname: getElementsByClassname,
  getFirstElementByTagName: getFirstElementByTagName,
  getHeadElement: getHeadElement,
  getParentByClassName: getParentByClassName,
  hasClass: hasClass,
  hasClassInParents: hasClassInParents,
  removeClass: removeClass,
  stringToDocumentFragment: stringToDocumentFragment,
  toggleClass: toggleClass
});

export { getFirstElementByTagName as a, getBodyElement as b, getParentByClassName as c, getElementsByClassname as d, hasClass as e, addClass as f, getHeadElement as g, hasClassInParents as h, index as i, removeClass as r, stringToDocumentFragment as s, toggleClass as t };
/*                                 */
